// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"56079662","885":"c5756d12"}[chunkId] + ".chunk.js";
};